import store from '../store'
import { Platform, Notify } from 'quasar'

import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'

const routes = [
	// Not Authenticated
	{
		path: '/',
		component: () => import('layouts/NotAuthenticated.vue'),
		children: [
			{
				path: '',
				name: 'login',
				component: () => import('pages/login/Login.vue'),
				props: true,
			},
			{
				path: 'maintenance-login',
				name: 'maintenance-login',
				component: () => import('pages/login/Login.vue'),
				props: true,
			},
			{
				path: 'login-samsung',
				name: 'login-samsung',
				component: () => import('pages/login/Login.vue'),
				props: true,
			},
			{
				path: 'redirect-control-pannel-v2',
				name: 'redirect-control-pannel-v2',
				component: () => import('pages/login/Login.vue'),
				props: true,
			},
			{
				path: 'validate-user-data-intel-webinar',
				name: 'validate-user-data-intel-webinar',
				component: () => import('pages/login/Login.vue'),
				props: true,
			},
			{
				path: 'recover-password',
				name: 'recover-password',
				component: () => import('pages/login/RecoverPassword.vue'),
			},
			{
				path: 'recover-password/:username/:uidb64/:token',
				name: 'set-new-password',
				component: () => import('pages/login/SetNewPassword.vue'),
				props: true,
			},
			{
				path: 'set-password/:username/:uidb64/:token',
				name: 'set-password',
				component: () => import('pages/login/SetNewPassword.vue'),
				props: true,
			},
			{
				path: 'register',
				name: 'register',
				component: () => import('pages/login/Register.vue'),
			},
			{
				path: 'complete-register-intel',
				name: 'complete-register-intel',
				component: () => import('pages/login/Register.vue'),
			},
			{
				path: 'about',
				name: 'about',
				component: () => import('pages/institutional/About.vue'),
			},
			{
				path: 'privacy',
				name: 'privacy',
				component: () => import('pages/institutional/Privacy.vue'),
			},
			{
				path: 'terms',
				name: 'terms',
				component: () => import('pages/institutional/Terms.vue'),
			},
			{
				path: 'help',
				name: 'login-help',
				component: () => import('pages/institutional/Help.vue'),
			},
		],

		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}
			if (to.name === 'set-password' && to.params.username != undefined) {
				if (Platform.is.mobile && !Platform.is.cordova) {
					window.location = `${
						process.env.APP_CORDOVA_URL
					}://set-password/?origin=set-password&username=${to.params.username}&uidb64=${
						to.params.uidb64
					}&token=${to.params.token}`
				}
			}
			// Nova mensagem
			if (to.query.message_id != undefined) {
				if (Platform.is.mobile && !Platform.is.cordova) {
					window.location = `${
						process.env.APP_CORDOVA_URL
					}://?origin=message&message_id=${to.query.message_id}`
				}
			}

			if (store.getters['common/access_token'] && to.name !== 'login-samsung') {
				let clients = store.getters['params/clients']
				let id_user_client_selected = store.getters['common/id_user_client_selected']
				let obj = clients.find((obj) => obj.id === id_user_client_selected)

				if (obj) {
					if (obj.home_route) {
						next({ name: obj.home_route, query: to.query })
					} else {
						if (obj.has_home) {
							next({ name: 'home', query: to.query })
						}
					}
				}
			} else {
				clearUserData()
				next()
			}
		},
	},

	// User Authenticated
	{
		path: '/',
		component: () => import('layouts/Authenticated.vue'),
		children: [
			{
				path: 'home',
				name: 'home',
				component: () =>
					Platform.is.mobile
						? import('pages/home/HomeMobile.vue')
						: import('pages/home/Home.vue'),
				meta: { title: 'home' },
			},
			{
				path: 'feed',
				name: 'feed',
				component: () => import('pages/feed/Feed.vue'),
				meta: { title: 'feed' },
			},
			{
				path: 'calendar',
				name: 'calendar',
				component: () => import('pages/calendar/Calendar.vue'),
				meta: { title: 'calendar' },
			},
			{
				path: 'profile',
				name: 'profile',
				component: () => import('pages/profile/Profile.vue'),
				meta: { title: 'profile' },
			},
			{
				path: 'profile',
				name: 'profile_basic_data',
				component: () => import('pages/profile/Profile.vue'),
				meta: { title: 'profile' },
			},
			{
				path: 'profile',
				name: 'profile_certificates',
				component: () => import('pages/profile/Profile.vue'),
				meta: { title: 'profile' },
			},
			{
				path: 'institutional/help',
				name: 'help',
				component: () => import('pages/institutional/Help.vue'),
				meta: { title: 'help' },
			},
			{
				path: 'institutional/faq',
				name: 'faq',
				component: () => import('pages/institutional/Faq.vue'),
				meta: { title: 'faq' },
			},
			{
				path: 'institutional/about',
				name: 'institutional-about',
				component: () => import('pages/institutional/About.vue'),
				meta: { title: 'about' },
			},
			{
				path: 'institutional/privacy',
				name: 'institutional-privacy',
				component: () => import('pages/institutional/Privacy.vue'),
				meta: { title: 'privacy' },
			},
			{
				path: 'institutional/terms',
				name: 'institutional-terms',
				component: () => import('pages/institutional/Terms.vue'),
				meta: { title: 'terms' },
			},
			{
				path: 'messages',
				name: 'messages',
				component: () => import('pages/messages/Messages.vue'),
				meta: { title: 'messages' },
			},
		],

		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}

			if (!store.getters['common/access_token']) {
				clearUserData()
				store.dispatch('redirect/SET_REDIRECT', [to.path])
				next({ name: 'login' })
			} else if (!store.getters['params/params_loaded']) {
				checkAllowed(next, to, from, 'authenticated')
			} else {
				if (store.getters['redirect/redirect'] !== '') {
					let redirect = store.getters['redirect/redirect']
					store.dispatch('redirect/SET_REDIRECT', [''])

					next({ path: redirect })
				} else if (store.getters['params/tmp_system_new_version'])
					checkSystemNewVersion(next)
				else {
					next()
				}
			}
		},
	},

	//Admin
	{
		path: '/admin',
		component: () => import('layouts/Admin.vue'),
		children: [
			{
				path: 'overview',
				name: 'admin_overview',
				component: () => import('pages/admin/overview/Overview.vue'),
				meta: { title: 'overview' },
			},
			{
				path: 'tags',
				name: 'admin_tags',
				component: () => import('pages/admin/tag/Tags.vue'),
				meta: { title: 'tags' },
			},
			{
				path: 'tags/:id',
				name: 'admin_tag',
				component: () => import('pages/admin/tag/Tag.vue'),
				meta: { title: 'tags' },
				props: true,
			},
			{
				path: 'users',
				name: 'admin_users',
				component: () => import('pages/admin/users/Users.vue'),
				meta: { title: 'users' },
			},
			{
				path: 'users/:id',
				name: 'admin_user',
				component: () => import('pages/admin/users/User.vue'),
				meta: { title: 'users' },
				props: true,
			},
			{
				path: 'users-groups',
				name: 'admin_users_groups',
				component: () => import('pages/admin/users/UsersGroups.vue'),
				meta: { title: 'users_groups' },
			},
			{
				path: 'users-groups/:id',
				name: 'admin_users_group',
				component: () => import('pages/admin/users/UsersGroup.vue'),
				meta: { title: 'users_groups' },
				props: true,
			},
			{
				path: 'home',
				name: 'admin_home',
				component: () => import('pages/admin/configuration/Home.vue'),
				meta: { title: 'home' },
			},
			{
				path: 'area_config',
				name: 'area_config',
				component: () => import('pages/admin/configuration/Areas.vue'),
				meta: { title: 'area_config' },
			},
			{
				path: 'mailing_list_config',
				name: 'mailing_list_config',
				component: () => import('pages/admin/configuration/MailingList.vue'),
				meta: { title: 'mailing_list' },
			},
			{
				path: 'admin-imports',
				name: 'admin_imports',
				component: () => import('pages/admin/imports/Imports.vue'),
				meta: { title: 'admin_import' },
			},
			{
				path: 'admin-import/:id',
				name: 'admin_import',
				component: () => import('pages/admin/imports/Import.vue'),
				meta: { title: 'admin_import' },
				props: true,
			},
			{
				path: 'organization-headquarters',
				name: 'admin_headquarters',
				component: () => import('pages/admin/organization/Headquarters.vue'),
				meta: { title: 'headquarter' },
			},
			{
				path: 'organization-headquarters/:id',
				name: 'admin_headquarter',
				component: () => import('pages/admin/organization/Headquarter.vue'),
				meta: { title: 'headquarter' },
				props: true,
			},
			{
				path: 'headquarter-import',
				name: 'admin_headquarter_import',
				component: () => import('pages/admin/organization/HeadquartersImport.vue'),
				meta: { title: 'headquarter_import' },
				props: true,
			},
			{
				path: 'organization-branches',
				name: 'admin_branches',
				component: () => import('pages/admin/organization/Branches.vue'),
				meta: { title: 'branch' },
			},
			{
				path: 'organization-branches/:id',
				name: 'admin_branch',
				component: () => import('pages/admin/organization/Branch.vue'),
				meta: { title: 'branch' },
				props: true,
			},
			{
				path: 'banners',
				name: 'admin_banners',
				component: () => import('pages/admin/banners/Banners.vue'),
				meta: { title: 'banners' },
			},

			{
				path: 'banners/:id',
				name: 'admin_banner',
				component: () => import('pages/admin/banners/Banner.vue'),
				meta: { title: 'banners' },
				props: true,
			},
			{
				path: 'banners-welcome',
				name: 'banners_welcome',
				component: () => import('pages/admin/banners_welcome/BannersWelcome.vue'),
				meta: { title: 'banners_welcome' },
			},
			{
				path: 'banners-welcome/:id',
				name: 'banner_welcome',
				component: () => import('pages/admin/banners_welcome/BannerWelcome.vue'),
				meta: { title: 'banners_welcome' },
				props: true,
			},
			{
				path: 'surveys',
				name: 'admin_surveys',
				component: () => import('pages/admin/surveys/Surveys.vue'),
				meta: { title: 'surveys' },
			},
			{
				path: 'surveys/:id',
				name: 'admin_survey',
				component: () => import('pages/admin/surveys/Survey.vue'),
				meta: { title: 'surveys' },
			},
			{
				path: 'faqs',
				name: 'admin_faqs',
				component: () => import('pages/admin/faq/Faqs.vue'),
				meta: { title: 'faq' },
			},
			{
				path: 'faqs/:id',
				name: 'admin_faq',
				component: () => import('pages/admin/faq/Faq.vue'),
				meta: { title: 'faq' },
				props: true,
			},
			{
				path: 'messages',
				name: 'admin_messages',
				component: () => import('pages/admin/messages/Messages.vue'),
				meta: { title: 'messages' },
			},
			{
				path: 'messages/:id',
				name: 'admin_message',
				component: () => import('pages/admin/messages/Message.vue'),
				meta: { title: 'messages' },
				props: true,
			},
			{
				path: 'faq/categories',
				name: 'admin_faq_categories',
				component: () => import('pages/admin/faq/FaqCategories.vue'),
				meta: { title: 'faq_categories' },
			},
			{
				path: 'faq/categories/:id',
				name: 'admin_faq_category',
				component: () => import('pages/admin/faq/FaqCategory.vue'),
				meta: { title: 'faq_categories' },
				props: true,
			},
			{
				path: 'configuration',
				name: 'admin_config',
				component: () => import('pages/admin/configuration/Configuration.vue'),
				meta: { title: 'configuration' },
			},
			{
				path: 'terms',
				name: 'admin_terms',
				component: () => import('pages/admin/configuration/Terms.vue'),
				meta: { title: 'terms' },
			},
			{
				path: 'about',
				name: 'admin_about',
				component: () => import('pages/admin/configuration/About.vue'),
				meta: { title: 'about' },
			},
			{
				path: 'policy',
				name: 'admin_policy',
				component: () => import('pages/admin/configuration/Policy.vue'),
				meta: { title: 'policy' },
			},
			{
				path: 'badges',
				name: 'admin_badges',
				component: () => import('pages/admin/configuration/Badges.vue'),
				meta: { title: 'badges' },
			},
			{
				path: 'badges/:id',
				name: 'admin_badge',
				component: () => import('pages/admin/configuration/Badge.vue'),
				meta: { title: 'badges' },
				props: true,
			},
			{
				path: 'schedule',
				name: 'schedules',
				component: () => import('pages/admin/schedule/Schedules.vue'),
				meta: { title: 'schedule' },
			},
			{
				path: 'schedule/:id',
				name: 'schedule',
				component: () => import('pages/admin/schedule/Schedule.vue'),
				meta: { title: 'schedule' },
				props: true,
			},
			{
				path: 'reward/categories',
				name: 'reward_categories',
				component: () => import('pages/admin/rewards/RewardsCategories.vue'),
				meta: { title: 'reward_categories' },
			},
			{
				path: 'reward/categories/:id',
				name: 'reward_categorie',
				component: () => import('pages/admin/rewards/RewardsCategorie.vue'),
				meta: { title: 'reward_categories' },
				props: true,
			},
			{
				path: 'rewards/',
				name: 'rewards',
				component: () => import('pages/admin/rewards/Rewards.vue'),
				meta: { title: 'rewards' },
			},
			{
				path: 'rewards/:id',
				name: 'reward',
				component: () => import('pages/admin/rewards/Reward.vue'),
				meta: { title: 'rewards' },
				props: true,
			},
			{
				path: 'reward/banners_campaign',
				name: 'banners_campaign',
				component: () => import('pages/admin/banners_campaigns/Banners.vue'),
				meta: { title: 'banners_campaign' },
			},
			{
				path: 'reward/banners_campaign/:id',
				name: 'banner_campaign',
				component: () => import('pages/admin/banners_campaigns/Banner.vue'),
				meta: { title: 'banners_campaign' },
			},
			{
				path: 'reward_orders/',
				name: 'reward_orders',
				component: () => import('pages/admin/redeem/Redeems.vue'),
				meta: { title: 'reward_orders' },
			},
			{
				path: 'reward_orders/:id',
				name: 'reward_order',
				component: () => import('pages/admin/redeem/Redeem.vue'),
				meta: { title: 'reward_orders' },
				props: true,
			},
			{
				path: 'reward_sale_products/',
				name: 'reward_sale_products',
				component: () => import('pages/admin/products_points_table/Products.vue'),
				meta: { title: 'reward_sale_products' },
			},
			{
				path: 'reward_sale_products/:id',
				name: 'reward_sale_product',
				component: () => import('pages/admin/products_points_table/Product.vue'),
				meta: { title: 'reward_sale_products' },
				props: true,
			},
			{
				path: 'reward_brands/',
				name: 'reward_brands',
				component: () => import('pages/admin/products_points_table/Brands.vue'),
				meta: { title: 'reward_brands' },
			},
			{
				path: 'reward_brands/:id',
				name: 'reward_brand',
				component: () => import('pages/admin/products_points_table/Brand.vue'),
				meta: { title: 'reward_brands' },
				props: true,
			},
			{
				path: 'reward_sale_product_types/',
				name: 'reward_sale_product_types',
				component: () => import('pages/admin/products_points_table/ProductsTypes.vue'),
				meta: { title: 'reward_sale_product_types' },
			},
			{
				path: 'reward_sale_product_types/:id',
				name: 'reward_sale_product_type',
				component: () => import('pages/admin/products_points_table/ProductType.vue'),
				meta: { title: 'reward_sale_product_types' },
				props: true,
			},
			{
				path: 'reward_level/',
				name: 'users_reward_levels',
				component: () => import('pages/admin/rewards/RewardsLevels.vue'),
				meta: { title: 'users_reward_levels' },
			},
			{
				path: 'reward_level/:id',
				name: 'users_reward_level',
				component: () => import('pages/admin/rewards/RewardLevel.vue'),
				meta: { title: 'users_reward_levels' },
				props: true,
			},
			{
				path: 'photo_types/',
				name: 'photo_types',
				component: () => import('pages/admin/photo_types/PhotoTypes.vue'),
				meta: { title: 'reward_upload_file_types' },
			},
			{
				path: 'photo_types/:id',
				name: 'photo_type',
				component: () => import('pages/admin/photo_types/PhotoType.vue'),
				meta: { title: 'reward_upload_file_types' },
				props: true,
			},
			{
				path: 'events/',
				name: 'events',
				component: () => import('pages/admin/events/Events.vue'),
				meta: { title: 'events_qrcode' },
			},
			{
				path: 'event/:id',
				name: 'event',
				component: () => import('pages/admin/events/Event.vue'),
				meta: { title: 'events_qrcode' },
				props: true,
			},
			{
				path: 'campaigns/',
				name: 'campaigns',
				component: () => import('pages/admin/reward_campaigns/Campaigns.vue'),
				meta: { title: 'reward_campaigns' },
			},
			{
				path: 'campaign/:id',
				name: 'campaign',
				component: () => import('pages/admin/reward_campaigns/Campaign.vue'),
				meta: { title: 'reward_campaigns' },
				props: true,
			},
		],

		beforeEnter: (to, from, next) => {
			if (process.env.PROJECT_FOLDER === 'itpiry') {
				try {
					wap_tms.custom.trackGaVirtualPageView(to.name, to.query)
				} catch (err) {
					console.log(err)
				}
			}

			if (!store.getters['common/access_token']) {
				next({ name: 'login' })
			} else {
				checkAllowed(next, to, from, 'admin')
			}
		},
	},
	{
		path: '/app-store',
		component: () => import('pages/app-store/AppStore.vue'),
		name: 'app-store',
	},
]

if (process.env.MODE !== 'ssr') {
	routes.push({
		path: '*',
		component: () => import('pages/Error404.vue'),
	})
}

export default routes

function checkAllowed(next, to, from, module_to) {
	let super_user_routes = [
		'admin_config',
		'admin_terms',
		'admin_about',
		'admin_policy',
		'admin_badges',
		'admin_badge',
		'admin_imports',
		'admin_home',
		'import_code',
		'area_config',
	]
	let special_permissions = ['appointments']

	if (
		module_to == 'admin' &&
		!super_user_routes.includes(to.name) &&
		!special_permissions.includes(to.meta.title)
	) {
		var access_level = store.getters['common/user_module_items']
		var allowed = false

		if (access_level.length > 0) {
			var obj_raw = access_level.find((obj) => {
				return obj.slug == to.meta.title
			})
			if (obj_raw) allowed = obj_raw.permission
		}

		if (allowed) next()
		else if (from.path === '/' || from.name === 'set-new-password') {
			Notify.create({
				message: 'Usuário não possui acesso ao painel de controle!',
				type: 'negative',
			})

			clearUserData()
			clearFireBase()
			next({ name: 'login' })
		} else notAllowed(next)
	} else if (module_to == 'admin' && super_user_routes.includes(to.name)) {
		if (store.getters['common/is_superuser']) {
			next()
		} else notAllowed(next)
	} else if (module_to == 'admin' && special_permissions.includes(to.meta.title)) {
		let has_permission = false

		let obj = store.getters['common/user_module_items'].find((obj) => {
			return obj.slug === 'request_events'
		})
		if (obj && obj.permission === true) has_permission = true

		obj = store.getters['common/user_module_items'].find((obj) => {
			return obj.slug === 'approve_events'
		})
		if (obj && obj.permission === true) has_permission = true

		obj = store.getters['common/user_module_items'].find((obj) => {
			return obj.slug === 'finish_events'
		})
		if (obj && obj.permission === true) has_permission = true

		if (has_permission) {
			next()
		} else notAllowed(next)
	} else next()
}

function notAllowed(next) {
	let clients = store.getters['params/clients']
	let id_user_client_selected = store.getters['common/id_user_client_selected']
	let obj = clients.find((obj) => {
		return obj.id == id_user_client_selected
	})
	next(obj.home_route)
}

function clearUserData() {
	store.dispatch('common/SET_ACCESS_TOKEN', ['', '', ''])
	store.dispatch('common/SET_USER_DATA', [
		'',
		'',
		'',
		'',
		'',
		'',
		'',
		[],
		[],
		[],
		[],
		,
		false,
		'',
		[],
		false,
		'',
		[],
		[],
		'',
	])
}

function clearFireBase() {
	firebase
		.auth()
		.signOut()
		.then(() => {})
		.catch((e) => {
			console.log(e)
		})
}

function checkSystemNewVersion(next) {
	var access_level = store.getters['common/user_module_items']
	var allowed = false
	if (access_level.length > 0) {
		var obj_raw = access_level.find((obj) => {
			return obj.permission == true
		})
		if (obj_raw) allowed = obj_raw.permission
		if (allowed) next({ name: 'admin_overview' })
		else {
			clearUserData()
			clearFireBase()
			next({ name: 'login' })
		}
	} else {
		clearUserData()
		clearFireBase()
		next({ name: 'login' })
	}
}
